import CookiePage from './../page/CookiePage.js';
import Cookie from "@templates/App/Cookies.js";

const CookieBar = {

    forbiddenUrls: [
        "zasady-spracuvania-osobnych-udajov",
        "cookies-jp-auto-nitra"
    ],

    init() {
        this.forbiddenUrls = window.T.global.cookies_bar.forbiddenUrls;

        this.el = $('[component="CookieBar"]');
        if (!this.el.length) return;

        this.cookieToggle = $('a.cookieBar-toggle');
        this.okButton = this.el.find('button.agree');
        this.declineButton = this.el.find('button.decline');
        this.settingsButton = this.el.find('a.button.settings');
        this.closeButton = this.el.find('.close');
        this.bind();
        this.show();
    },

    bind() {
        this.cookieToggle.on('click', CookieBar.open);
        this.okButton.on('click', CookieBar.close);
        this.declineButton.on('click', CookieBar.remove);
        this.settingsButton.on('click', CookieBar.remove);
        this.closeButton.on('click', CookieBar.remove);
    },

    show() {
        const url = window.location.pathname.split("/").slice(-1).toString();

        if (Cookie.get(CookiePage.cookieName) || this.forbiddenUrls.includes(url))
            return;

        this.open();
    },

    hide(){
        CookieBar.el.removeClass('visible');
    },

    close() {
        CookiePage.acceptAllCookies();
        CookieBar.hide();
    },

    open() {
        CookieBar.el.addClass('visible');
    },

    remove() {
        CookiePage.acceptEssentialCookies();
        CookieBar.hide();
    }
}
export default CookieBar;